export const iframeConnect = (proc)=>{
    proc.setData({
        origins:['localhost:7456']
    })
}